import React from 'react';
import WorkshopCard from './WorkshopCard';

const WorkshopGrid = ({ items }) => {
  return (
    <div className='grid w-full grid-cols-1 gap-0 tabletH:grid-cols-2 tabletH:gap-10 desktopL:grid-cols-3'>
      {items.map((item, index) => (
        <div key={item.id || index} className='min-w-0 w-full'>
          <WorkshopCard {...item} />
        </div>
      ))}
    </div>
  );
};

export default WorkshopGrid;

